import { useState } from 'react';
import { FaStop } from 'react-icons/fa';

import JobApi from 'api/job';
import AlertHelper from 'helpers/AlertHelper';
import NotificationHelper from 'helpers/NotificationHelper';

import { Resources } from 'helpers/ResourceHelper';
import { useAuth } from 'providers/auth';

const JobStopButton = job => {
  const [stopping, setStopping] = useState(false);

  const { isAuthorized } = useAuth();

  if (!isAuthorized(Resources.BOT_MANAGER)) {
    return null;
  }

  if (job.status !== 'WORKING' && job.status !== 'PENDING') {
    return null;
  }

  const stopJob = async () => {
    const result = await AlertHelper.confirm({
      title: `Parar execução`,
      html: `Deseja realmente parar esta execução?`,
    });

    if (result.value) {
      setStopping(true);
      try {
        await JobApi.stop(job.id);
      } catch (error) {
        console.error(error);
        NotificationHelper.snack('Ocorreu um erro ao solicitar parar a execução.');
      } finally {
        setStopping(false);
      }
    }
  };

  return (
    <div className="lh-sm">
      <button className="btn text-danger" title="Parar execução" disabled={stopping} onClick={stopJob}>
        <FaStop size={22} />
      </button>
    </div>
  );
};

export default JobStopButton;
